var _g, _g2, _g3, _g4, _g5, _g6, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPocketPathologistIconLearningTransparent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 700",
    enableBackground: "new 0 0 700 700",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_x33_"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "_x34_"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "_x35_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BDABD3",
    d: "M353.6,257.46H125.72c-13.31,0-24.1,10.79-24.1,24.1v218.61c0,15.89,16.87,26.13,30.94,18.75 c38.62-20.27,110.64-43.53,200.29-5.1c13.25,5.68,28.25,5.68,41.5,0c89.65-38.43,161.67-15.17,200.29,5.1 c14.07,7.38,30.94-2.86,30.94-18.75V281.56c0-13.31-10.79-24.1-24.1-24.1H353.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9076B6",
    d: "M136.95,292.24c0,0-34.52,193.19-17.27,205.49c17.26,12.3,93.29-26.46,156.12-13.17 c68.42,14.47,46.03,31.3,84.92,30.35c12.86-0.31,69.56-52.48,163.22-30.08c39.43,9.43,60.63,33.47,69.76,12.9 c9.12-20.57-10.32-196.79-10.32-196.79S418.8,193.01,353.6,287.98C300.04,268.53,139.49,248.64,136.95,292.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0E1E6",
    d: "M581.75,255.45v226.64c0,8.11-8.55,13.37-15.78,9.72c-32.19-16.28-110.54-44.38-206.46,2.86 c-1.86,0.92-3.88,1.38-5.9,1.38c-2.02,0-4.05-0.46-5.91-1.38c-95.92-47.24-174.28-19.14-206.46-2.86 c-7.24,3.66-15.78-1.61-15.78-9.72V255.45c0-7.37,2.76-14.47,7.76-19.88c66.8-72.12,161.4-40.98,201.38-22.83 c2.75,1.24,5.24,2.43,7.45,3.52c3.65,1.8,7.6,2.7,11.56,2.7s7.91-0.9,11.56-2.7c34.28-16.89,137.43-57.77,208.83,19.32 C578.99,240.97,581.75,248.08,581.75,255.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#98D0D7",
    d: "M566.99,456.25c-40.66-23.98-117.41-51.01-205.86,8.49c-4.55,3.06-10.5,3.06-15.05,0 c-88.45-59.5-165.19-32.46-205.86-8.49c-9.15,5.39-14.77,15.21-14.77,25.83l0,0c0,8.11,8.55,13.37,15.78,9.72 c32.18-16.28,110.54-44.38,206.46,2.86c1.86,0.92,3.89,1.38,5.91,1.38v0c0,0,0,0,0,0c0,0,0,0,0,0v0c2.02,0,4.04-0.46,5.91-1.38 c95.92-47.24,174.28-19.14,206.46-2.86c7.24,3.66,15.78-1.61,15.78-9.72l0,0C581.75,471.47,576.13,461.65,566.99,456.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0C899B",
    strokeWidth: 4.9643,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M155.31,251.08c0,0,86-62.99,162.14,0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0C899B",
    strokeWidth: 4.9643,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M155.31,281.87c0,0,86-62.99,162.14,0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0C899B",
    strokeWidth: 4.9643,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M155.31,314.28c0,0,86-62.99,162.14,0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0C899B",
    strokeWidth: 4.9643,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M155.31,345.07c0,0,86-62.99,162.14,0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0C899B",
    strokeWidth: 4.9643,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M155.31,376.94c0,0,86-62.99,162.14,0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0C899B",
    strokeWidth: 4.9643,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M155.31,407.73c0,0,86-62.99,162.14,0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0C899B",
    strokeWidth: 4.9643,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M551.34,250.05c0,0-86-62.99-162.14,0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0C899B",
    strokeWidth: 4.9643,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M551.34,280.84c0,0-86-62.99-162.14,0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0C899B",
    strokeWidth: 4.9643,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M551.34,313.25c0,0-86-62.99-162.14,0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0C899B",
    strokeWidth: 4.9643,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M551.34,344.04c0,0-86-62.99-162.14,0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0C899B",
    strokeWidth: 4.9643,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M551.34,375.91c0,0-86-62.99-162.14,0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0C899B",
    strokeWidth: 4.9643,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M551.34,406.7c0,0-86-62.99-162.14,0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#98D0D7",
    d: "M353.6,218.95v73.3c0,0-4.65-51.5-19.01-79.51c2.75,1.24,5.24,2.43,7.45,3.52 C345.69,218.05,349.64,218.95,353.6,218.95z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "_x36_"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPocketPathologistIconLearningTransparent);
export default __webpack_public_path__ + "static/media/Pocket Pathologist-Icon_Learning-transparent.ec0dc8d28f6ad850d5613454225536b0.svg";
export { ForwardRef as ReactComponent };